module.exports = __webpack_public_path__ + "static/media/1_15.067ff02a.png";